export default __webpack_public_path__ + "static/media/property_860.ad90cd52.png";